import type { StepListener } from '../types';
import type { TssEventEnvelope, UIEventPayload } from './envelope';

/**
 * Selects the reaction owned by the control that emitted an event.
 *
 * Source fields are optional for 0.22.0 compatibility. When a listener declares
 * either field, a missing or different event-context value fails closed.
 */
export function matchesListenerSource(
  listener: StepListener,
  envelope: TssEventEnvelope
): boolean {
  const config = listener.config as Record<string, unknown>;
  const sourceBlockId = config.sourceBlockId;
  const sourceTrigger = config.sourceTrigger;
  const context = (envelope.payload as UIEventPayload | undefined)?.context;

  if (sourceBlockId !== undefined) {
    if (
      typeof sourceBlockId !== 'string' ||
      context?.blockId !== sourceBlockId
    ) {
      return false;
    }
  }
  if (sourceTrigger !== undefined) {
    if (
      typeof sourceTrigger !== 'string' ||
      context?.trigger !== sourceTrigger
    ) {
      return false;
    }
  }
  return true;
}
